import React, { useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { css } from "@emotion/core";
import Loader from "react-spinners/ClimbingBoxLoader";
import { Links } from "./util/util";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import NavBar from "./components/NavBar";
import Menu from "./components/Menu";
import "./assets/scss/main.scss";
import "bootstrap/dist/js/bootstrap.min.js";
import Footer from "./components/Footer";
import Subscribe from "./components/Subscribe";
import ScrollToTop from "./components/ScrollToTop";

import ReactGA from "react-ga4";

ReactGA.initialize("G-22YJ0F86YW");

const override = css`
  display: block;
  margin: 0 auto;
  border-color: var(--primary);
  position: absolute; /*it can be fixed too*/
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

const Home = React.lazy(() => import("./pages/Home"));
const ContactUS = React.lazy(() => import("./pages/ContactUs"));
const About = React.lazy(() => import("./pages/About"));
const OurWork = React.lazy(() => import("./pages/OurWork"));
const RideHailing = React.lazy(() => import("./pages/projects/RideHailing"));
const BendInTrend = React.lazy(() => import("./pages/projects/BendInTrend"));
const NotFound = React.lazy(() => import("./pages/404"));
const StitchIt = React.lazy(() => import("./pages/projects/StitchIt"));

export default () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const handleMenuClick = () => setMenuOpen(true);

    const handleMenuClose = () => setMenuOpen(false);

    return (
        <React.Suspense fallback={
            <Loader
                css={override}
                sizeUnit={"px"}
                size={25}
                color={"var(--primary)"}
            />
        }>
            <BrowserRouter className="App">
                <Route render={({ location }) => (
                    <TransitionGroup>
                        <CSSTransition key={location.key} timeout={500} in={true} classNames="page">
                            <div>
                                <NavBar handleMenuClick={handleMenuClick} />
                                <div className="page-root">
                                    <Menu open={menuOpen} handleClose={handleMenuClose} />

                                    <Switch location={location}>
                                        <Route path={Links.HOME} exact component={Home} />
                                        <Route path={Links.WORK} exact component={OurWork} />
                                        <Route path={Links.CONTACT} exact component={ContactUS} />
                                        <Route path={Links.ABOUT} exact component={About} />
                                        <Route path={Links.CASE_RIDE_HAILING} exact component={RideHailing} />
                                        <Route path={Links.CASE_BEND_IN_TREND} exact component={BendInTrend} />
                                        <Route path={Links.CASE_STITCH_IT} exact component={StitchIt} />
                                        <Route path="*" exact component={NotFound} />
                                    </Switch>

                                    <div>
                                        <Subscribe />
                                        <Footer pageName="home" />
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    </TransitionGroup>
                )}
                />
                <ScrollToTop />
            </BrowserRouter>
        </React.Suspense>
    );
}
